import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaXTwitter,
  FaYoutube,
  FaInstagram,
  FaWhatsapp,
  FaGithub,
} from 'react-icons/fa6';

function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand-column">
            <div className="footer-brand">
              <div className="nav-mark">F</div>
              FaithConnect
            </div>

            <p className="footer-brand-description">
              Church member care software for attendance, follow-up, and
              communication — built in Ghana, for Africa.
            </p>

            <div className="footer-social">
              <a
                href="#"
                aria-label="Facebook"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF size={18} />
              </a>

              <a
                href="#"
                aria-label="X"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter size={18} />
              </a>

              <a
                href="#"
                aria-label="YouTube"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube size={18} />
              </a>

              <a
                href="#"
                aria-label="Instagram"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={18} />
              </a>

              <a
                href="#"
                aria-label="WhatsApp"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp size={18} />
              </a>

              <a
                href="#"
                aria-label="GitHub"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGithub size={18} />
              </a>
            </div>
          </div>

          {/* Product Column */}
          <div className="footer-col">
            <h4>Product</h4>
            <Link to="/features">Features</Link>
            <Link to="/pricing">Pricing</Link>
          </div>

          {/* Company Column */}
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/blog">Blog</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/contact">Contact Us</Link>
          </div>

          {/* Support Column */}
          <div className="footer-col">
            <h4>Support</h4>
            <Link to="/faq">Help Center</Link>
            <Link to="/contact">WhatsApp Us</Link>
            <Link to="/contact">Book a Demo</Link>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <span className="footer-copyright">
            © 2026 FaithConnect. All rights reserved.
          </span>

          <div className="footer-legal-links">
            <Link to="/privacy" className="footer-legal-link">
              Privacy Policy
            </Link>

            <span className="footer-legal-divider">•</span>

            <Link to="/terms" className="footer-legal-link">
              Terms of Service
            </Link>

            <span className="footer-legal-divider">•</span>

            <span className="footer-location">Accra, Ghana</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;